export enum EcomEvent {
  START = 'START',
  CLOSE = 'CLOSE',
  CONFIRM_CLOSE_ACTIVE = 'CONFIRM_CLOSE_ACTIVE',
  CONFIRM_CLOSE_CONFIRMED = 'CONFIRM_CLOSE_CONFIRMED',
  CONFIRM_CLOSE_ABORTED = 'CONFIRM_CLOSE_ABORTED',

  PREVIEW_PROCEED = 'PREVIEW_PROCEED',

  CENTRAL_STORAGE_ACTIVE = 'CENTRAL_STORAGE_ACTIVE',
  CENTRAL_STORAGE_EDIT = 'CENTRAL_STORAGE_EDIT',
  CENTRAL_STORAGE_SELECTED = 'CENTRAL_STORAGE_SELECTED',
  CENTRAL_STORAGE_SET = 'CENTRAL_STORAGE_SET',

  CUSTOMER_ACTIVE = 'CUSTOMER_ACTIVE',
  CUSTOMER_EDIT = 'CUSTOMER_EDIT',
  CUSTOMER_EMAIL_AND_PHONE_SET = 'CUSTOMER_EMAIL_AND_PHONE_SET',
  CUSTOMER_ADDRESS_BY_SSN_REQUESTED = 'CUSTOMER_ADDRESS_BY_SSN_REQUESTED',
  CUSTOMER_ADDRESS_BY_SSN_SUCCEEDED = 'CUSTOMER_ADDRESS_BY_SSN_SUCCEEDED',
  CUSTOMER_ADDRESS_BY_SSN_FAILED = 'CUSTOMER_ADDRESS_BY_SSN_FAILED',
  CUSTOMER_ADDRESS_SET = 'CUSTOMER_ADDRESS_SET',

  FINANCIAL_INFORMATION_TOGGLE = 'FINANCIAL_INFORMATION_TOGGLE',
  FINANCIAL_ACTIVE = 'FINANCIAL_ACTIVE',
  FINANCIAL_EDIT = 'FINANCIAL_EDIT',
  FINANCIAL_CASH_SELECTED = 'FINANCIAL_CASH_SELECTED',
  FINANCIAL_LOAN_SELECTED = 'FINANCIAL_LOAN_SELECTED',
  FINANCIAL_LEASE_SELECTED = 'FINANCIAL_LEASE_SELECTED',
  FINANCIAL_CASH_SET = 'FINANCIAL_CASH_SET',
  FINANCIAL_LEASE_SET = 'FINANCIAL_LEASE_SET',
  FINANCIAL_LOAN_SET = 'FINANCIAL_LOAN_SET',
  FINANCIAL_LOAN_DOWNPAYMENT_INFORMATION_TOGGLE = 'FINANCIAL_LOAN_DOWNPAYMENT_INFORMATION_TOGGLE',
  FINANCIAL_LOAN_KYC_INFORMATION_TOGGLE = 'FINANCIAL_LOAN_KYC_INFORMATION_TOGGLE',
  FINANCIAL_LOAN_HOUSEHOLD_CHILDREN_INFORMATION_TOGGLE = 'FINANCIAL_LOAN_HOUSEHOLD_CHILDREN_INFORMATION_TOGGLE',
  FINANCIAL_LOAN_HOUSEHOLD_INCOME_INFORMATION_TOGGLE = 'FINANCIAL_LOAN_HOUSEHOLD_INCOME_INFORMATION_TOGGLE',
  FINANCIAL_LOAN_HOUSEHOLD_COST_INFORMATION_TOGGLE = 'FINANCIAL_LOAN_HOUSEHOLD_COST_INFORMATION_TOGGLE',
  FINANCIAL_LOAN_HOUSEHOLD_DEBT_INFORMATION_TOGGLE = 'FINANCIAL_LOAN_HOUSEHOLD_DEBT_INFORMATION_TOGGLE',
  FINANCIAL_CREDIT_SCORING_ABORTED = 'FINANCIAL_CREDIT_SCORING_ABORTED',
  FINANCIAL_CREDIT_SCORING_CREATE_CASE_REQUESTED = 'FINANCIAL_CREDIT_SCORING_CREATE_CASE_REQUESTED',
  FINANCIAL_CREDIT_SCORING_CREATE_CASE_SUCCEEDED = 'FINANCIAL_CREDIT_SCORING_CREATE_CASE_SUCCEEDED',
  FINANCIAL_CREDIT_SCORING_CREATE_CASE_FAILED = 'FINANCIAL_CREDIT_SCORING_CREATE_CASE_FAILED',
  FINANCIAL_CREDIT_SCORING_BANKID_INIT_REQUESTED = 'FINANCIAL_CREDIT_SCORING_BANKID_INIT_REQUESTED',
  FINANCIAL_CREDIT_SCORING_BANKID_INIT_SUCCEEDED = 'FINANCIAL_CREDIT_SCORING_BANKID_INIT_SUCCEEDED',
  FINANCIAL_CREDIT_SCORING_BANKID_INIT_FAILED = 'FINANCIAL_CREDIT_SCORING_BANKID_INIT_FAILED',
  FINANCIAL_CREDIT_SCORING_BANKID_STATUS_QR_REQUESTED = 'FINANCIAL_CREDIT_SCORING_BANKID_STATUS_QR_REQUESTED',
  FINANCIAL_CREDIT_SCORING_BANKID_STATUS_QR_SUCCEEDED = 'FINANCIAL_CREDIT_SCORING_BANKID_STATUS_QR_SUCCEEDED',
  FINANCIAL_CREDIT_SCORING_BANKID_STATUS_SAME_DEVICE_REQUESTED = 'FINANCIAL_CREDIT_SCORING_BANKID_STATUS_SAME_DEVICE_REQUESTED',
  FINANCIAL_CREDIT_SCORING_BANKID_STATUS_SAME_DEVICE_SUCCEEDED = 'FINANCIAL_CREDIT_SCORING_BANKID_STATUS_SAME_DEVICE_SUCCEEDED',
  FINANCIAL_CREDIT_SCORING_SIGNING_SIGNED = 'FINANCIAL_CREDIT_SCORING_SIGNING_SIGNED',
  FINANCIAL_CREDIT_SCORING_SIGNING_SCORED = 'FINANCIAL_CREDIT_SCORING_SIGNING_SCORED',

  TRADE_IN_ACTIVE = 'TRADE_IN_ACTIVE',
  TRADE_IN_EDIT = 'TRADE_IN_EDIT',
  TRADE_IN_SELECTED = 'TRADE_IN_SELECTED',
  TRADE_IN_SKIPPED = 'TRADE_IN_SKIPPED',
  TRADE_IN_CONDITION_VERY_GOOD_SELECTED = 'TRADE_IN_CONDITION_VERY_GOOD_SELECTED',
  TRADE_IN_CONDITION_GOOD_SELECTED = 'TRADE_IN_CONDITION_GOOD_SELECTED',
  TRADE_IN_CONDITION_OK_SELECTED = 'TRADE_IN_CONDITION_OK_SELECTED',
  TRADE_IN_VALUATION_REQUESTED = 'TRADE_IN_VALUATION_REQUESTED',
  TRADE_IN_VALUATION_SUCCEEDED = 'TRADE_IN_VALUATION_SUCCEEDED',
  TRADE_IN_VALUATION_FAILED = 'TRADE_IN_VALUATION_FAILED',
  TRADE_IN_SET = 'TRADE_IN_SET',

  INSURANCE_ACTIVE = 'INSURANCE_ACTIVE',
  INSURANCE_EDIT = 'INSURANCE_EDIT',
  INSURANCE_MILEAGE_BETWEEN_0_AND_1000_SELECTED = 'INSURANCE_MILEAGE_BETWEEN_0_AND_1000_SELECTED',
  INSURANCE_MILEAGE_BETWEEN_1000_AND_1500_SELECTED = 'INSURANCE_MILEAGE_BETWEEN_1000_AND_1500_SELECTED',
  INSURANCE_MILEAGE_BETWEEN_1500_AND_2000_SELECTED = 'INSURANCE_MILEAGE_BETWEEN_1500_AND_2000_SELECTED',
  INSURANCE_MILEAGE_BETWEEN_2000_AND_2500_SELECTED = 'INSURANCE_MILEAGE_BETWEEN_2000_AND_2500_SELECTED',
  INSURANCE_MILEAGE_OVER_2500_SELECTED = 'INSURANCE_MILEAGE_OVER_2500_SELECTED',
  INSURANCE_EDIT_MILEAGE = 'INSURANCE_EDIT_MILEAGE',
  INSURANCE_SKIPPED = 'INSURANCE_SKIPPED',
  INSURANCE_SHOW = 'INSURANCE_SHOW',
  INSURANCE_SET = 'INSURANCE_SET',
  INSURANCE_SELECTED = 'INSURANCE_SELECTED',
  INSURANCE_UNSELECTED = 'INSURANCE_UNSELECTED',
  INSURANCE_ADDON_SELECTED = 'INSURANCE_ADDON_SELECTED',
  INSURANCE_ADDON_UNSELECTED = 'INSURANCE_ADDON_UNSELECTED',
  INSURANCE_GET_INSURANCES_REQUESTED = 'INSURANCE_GET_INSURANCES_REQUESTED',
  INSURANCE_GET_INSURANCES_SUCCEEDED = 'INSURANCE_GET_INSURANCES_SUCCEEDED',
  INSURANCE_GET_INSURANCES_FAILED = 'INSURANCE_GET_INSURANCES_FAILED',
  INSURANCE_INFORMATION_TOGGLE = 'INSURANCE_INFORMATION_TOGGLE',
  INSURANCE_ARROW = 'INSURANCE_ARROW',

  DELIVERY_ACTIVE = 'DELIVERY_ACTIVE',
  DELIVERY_EDIT = 'DELIVERY_EDIT',
  DELIVERY_DEALER_SELECTED = 'DELIVERY_DEALER_SELECTED',
  DELIVERY_HOME_SELECTED = 'DELIVERY_HOME_SELECTED',
  DELIVERY_DEALER_SET = 'DELIVERY_DEALER_SET',
  DELIVERY_HOME_SET = 'DELIVERY_HOME_SET',

  ACCESSORY_ACTIVE = 'ACCESSORY_ACTIVE',
  ACCESSORY_EDIT = 'ACCESSORY_EDIT',
  ACCESSORY_EXPOSURE = 'ACCESSORY_EXPOSURE',
  ACCESSORY_SKIPPED = 'ACCESSORY_SKIPPED',
  ACCESSORY_SELECTED = 'ACCESSORY_SELECTED',
  ACCESSORY_UNSELECTED = 'ACCESSORY_UNSELECTED',
  ACCESSORY_INFORMATION_OPEN = 'ACCESSORY_INFORMATION_OPEN',
  ACCESSORY_INFORMATION_CLOSE = 'ACCESSORY_INFORMATION_CLOSE',
  ACCESSORY_INFORMATION_GALLERY_IMAGE_PAGING = 'ACCESSORY_INFORMATION_GALLERY_IMAGE_PAGING',
  ACCESSORY_ARROWS = 'ACCESSORY_ARROWS',

  CONFIRMATION_BANKID_ABORTED = 'CONFIRMATION_BANKID_ABORTED',
  CONFIRMATION_BANKID_INIT_REQUESTED = 'CONFIRMATION_BANKID_INIT_REQUESTED',
  CONFIRMATION_BANKID_INIT_SUCCEEDED = 'CONFIRMATION_BANKID_INIT_SUCCEEDED',
  CONFIRMATION_BANKID_INIT_FAILED = 'CONFIRMATION_BANKID_INIT_FAILED',
  CONFIRMATION_BANKID_STATUS_QR_REQUESTED = 'CONFIRMATION_BANKID_STATUS_QR_REQUESTED',
  CONFIRMATION_BANKID_STATUS_QR_SUCCEEDED = 'CONFIRMATION_BANKID_STATUS_QR_SUCCEEDED',
  CONFIRMATION_BANKID_STATUS_QR_SUCCEEDED_NOT_OVER_18 = 'CONFIRMATION_BANKID_STATUS_QR_SUCCEEDED_NOT_OVER_18',
  CONFIRMATION_BANKID_STATUS_QR_SUCCEEDED_SSN_MISSMATCH = 'CONFIRMATION_BANKID_STATUS_QR_SUCCEEDED_SSN_MISSMATCH',
  CONFIRMATION_BANKID_STATUS_SAME_DEVICE_REQUESTED = 'CONFIRMATION_BANKID_STATUS_SAME_DEVICE_REQUESTED',
  CONFIRMATION_BANKID_STATUS_SAME_DEVICE_SHOULD_RENEW = 'CONFIRMATION_BANKID_STATUS_SAME_DEVICE_SHOULD_RENEW',
  CONFIRMATION_BANKID_STATUS_SAME_DEVICE_SUCCEEDED = 'CONFIRMATION_BANKID_STATUS_SAME_DEVICE_SUCCEEDED',
  CONFIRMATION_BANKID_STATUS_SAME_DEVICE_SUCCEEDED_NOT_OVER_18 = 'CONFIRMATION_BANKID_STATUS_SAME_DEVICE_SUCCEEDED_NOT_OVER_18',
  CONFIRMATION_BANKID_STATUS_SAME_DEVICE_SUCCEEDED_SSN_MISSMATCH = 'CONFIRMATION_BANKID_STATUS_SAME_DEVICE_SUCCEEDED_SSN_MISSMATCH',
  CONFIRMATION_CREATE_ORDER_REQUESTED = 'CONFIRMATION_CREATE_ORDER_REQUESTED',
  CONFIRMATION_CREATE_ORDER_SUCCEEDED = 'CONFIRMATION_CREATE_ORDER_SUCCEEDED',
  CONFIRMATION_CREATE_ORDER_FAILED = 'CONFIRMATION_CREATE_ORDER_FAILED',
  CONFIRMATION_ACCEPT_CREDIT_ASSESSMENT_REQUEST = 'CONFIRMATION_ACCEPT_CREDIT_ASSESSMENT_REQUEST',
  CONFIRMATION_ACCEPT_CREDIT_ASSESSMENT_SUCCEEDED = 'CONFIRMATION_ACCEPT_CREDIT_ASSESSMENT_SUCCEEDED',
  CONFIRMATION_ACCEPT_CREDIT_ASSESSMENT_FAILED = 'CONFIRMATION_ACCEPT_CREDIT_ASSESSMENT_FAILED',

  SUMMARY_ACTIVE = 'SUMMARY_ACTIVE',
}

export enum EcomStep {
  CENTRAL_STORAGE = 'CENTRAL_STORAGE',

  CUSTOMER_EMAIL_AND_PHONE = 'CUSTOMER_EMAIL_AND_PHONE',
  CUSTOMER_ADDRESS = 'CUSTOMER_ADDRESS',

  FINANCIAL = 'FINANCIAL',
  FINANCIAL_CREDIT_SCORING = 'FINANCIAL_CREDIT_SCORING',

  TRADE_IN = 'TRADE_IN',
  TRADE_IN_DETAILS = 'TRADE_IN_DETAILS',

  INSURANCE = 'INSURANCE',
  INSURANCE_IF = 'INSURANCE_IF',

  DELIVERY = 'DELIVERY',

  ACCESSORY = 'ACCESSORY',

  CONFIRMATION = 'CONFIRMATION',
}

export enum EcomView {
  PREVIEW = 'PREVIEW',
  MAIN = 'MAIN',
  SUMMARY = 'SUMMARY',
}

type Listner = (
  view: EcomView,
  ecomEvent: EcomEvent,
  currentStep?: EcomStep,
  data?: { [key: string]: any }
) => void;

const listners: Listner[] = [];

export const registerEventListner = (fn: Listner) => {
  listners.push(fn);
};

export const unregisterEventListner = (fn: Listner) => {
  const index = listners.findIndex((f) => f === fn);
  if (index > -1) {
    listners.splice(index, 1);
  }
};

interface EventHistory {
  view: EcomView;
  ecomEvent: EcomEvent;
  currentStep?: EcomStep;
  data?: { [key: string]: any };
}

export const eventHistory: EventHistory[] = [];
export const getLastHistory = () => eventHistory[eventHistory.length - 1];
const ecomEvent = (
  view: EcomView,
  ecomEvent: EcomEvent,
  currentStep?: EcomStep,
  data?: { [key: string]: any }
) => {
  eventHistory.push({ view, ecomEvent, currentStep });
  listners.forEach((fn) => fn(view, ecomEvent, currentStep, data));
};

export default ecomEvent;
